import React from 'react'
import Button from '@material-ui/core/Button'
import { navigate } from 'gatsby'

function LinkButton(props) {
  return <Button {...props} onClick={e => { e.preventDefault(); navigate(props.href) }}>{props.children}</Button>
}

export default LinkButton